import authGetters from "./getters.js";
import authMutations from "./mutations.js";
import authActions from "./actions.js";

// This module works directly with Auth0 - All logic regarding Auth0 is stored here
export default {
  namespaced: true,
  state() {
    return {
      token: null,
    };
  },
  getters: authGetters,
  mutations: authMutations,
  actions: authActions,
};
